import { Config } from '#/global/helper/Config'

export const getSearchCompanyTag = () => {
    switch (Config.getShopId()) {
        case 'argos_cz':
            return 'argos'
        case 'dek_cz':
            return 'cz'
        case 'dek_sk':
            return 'sk'
        case 'stachema_cz':
            return 'stachema_cz'
        case 'stachema_sk':
            return 'stachema_sk'
        default:
            return 'cz'
    }
}
